// String keys and values, like localStorage. A failed read/write keeps working in memory.
export function createStorage(storage) {
  const memory = new Map();
  return {
    get(key, fallback = null) {
      try {
        const value = storage?.get ? storage.get(key, null) : storage?.getItem(key);
        if (value != null) { memory.set(key, value); return value; }
      } catch { /* unavailable storage */ }
      return memory.get(key) ?? fallback;
    },
    set(key, value) {
      memory.set(key, value);
      try { if (storage?.set) storage.set(key, value); else storage?.setItem(key, value); }
      catch { /* the choice is still kept in memory */ }
    },
  };
}

export function loadSettings(store, id, defaults = {}) {
  const merge = saved => ({ ...defaults, ...saved,
    outfit: { ...defaults.outfit, ...saved.outfit },
    parachute: { ...defaults.parachute, ...saved.parachute } });
  try {
    const saved = JSON.parse(store.get(`companion.${id}`, 'null'));
    if (saved && typeof saved === 'object' && !Array.isArray(saved)) return merge(saved);
  } catch { /* use the old choices or defaults */ }
  return merge({ skin: store.get(`${id}.color`, defaults.skin ?? 'original'),
    outfit: { head: store.get(`${id}.outfit.head`, defaults.outfit?.head ?? 'none'), body: store.get(`${id}.outfit.body`, defaults.outfit?.body ?? 'none') },
    parachute: { color: store.get(`${id}.chute.color`, defaults.parachute?.color ?? 'match'), pattern: store.get(`${id}.chute.pattern`, defaults.parachute?.pattern ?? 'plain') } });
}
